export default "__VITE_ASSET__FvFnI_CW__"